import { ErrorHandler } from '@angular/core';
import * as Sentry from '@sentry/angular';
import { isTenantAccessLostError } from '../tenant/tenant-access-lost.error';

/**
 * Sentry's handler, minus the expected "lost access to the organization" flow: when a
 * subscriber has no error callback, rxjs reports the rethrown TenantAccessLostError here
 * even though the user was already informed and redirected.
 */
export function createErrorHandler(): ErrorHandler {
  const sentryHandler = Sentry.createErrorHandler();
  return {
    handleError(error: unknown) {
      if (!isTenantAccessLostError(error)) {
        sentryHandler.handleError(error);
      }
    },
  };
}
